import React, {Component} from 'react';
import PropTypes from "prop-types";


class BooleanCheckCellRender extends Component {

  render() {
    return (
      <input type="checkbox" readOnly={true} checked={this.props.value == 1 ? true : false} />
    )
  }
}

BooleanCheckCellRender.propTypes = {
  value: PropTypes.any,
};

export default BooleanCheckCellRender;